<div
    #container
    data-testid="overflow-metadata-container"
    class="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1"
>
    @for (item of visibleItems(); track item.id) {
        <div class="flex min-w-0 items-center gap-2">
            @if (separator() && !$first) {
                <span aria-hidden="true" class="text-muted">{{
                    separator()
                }}</span>
            }
            <qpx-metadata
                [presentation]="presentation()"
                [id]="item.id"
                [icon]="item.icon"
                [label]="item.label"
                [value]="item.value"
                [ariaLabel]="item.ariaLabel"
                [trailingIcon]="item.trailingIcon"
                [trailingIconAriaLabel]="item.trailingIconAriaLabel"
                [trailingIconLabel]="item.trailingIconLabel"
                [trailingIconContext]="item.trailingIconContext"
            />
        </div>
    }

    @if (hasHiddenItems()) {
        <div class="relative size-4 shrink-0">
            <button
                #triggerButton
                #infoTrigger="cdkOverlayOrigin"
                cdkOverlayOrigin
                qpxButton
                matIconButton
                size="sm"
                class="absolute left-1/2 top-1/2 size-7! -translate-x-1/2 -translate-y-1/2"
                [attr.aria-controls]="popupId"
                [attr.aria-expanded]="cardOpen()"
                (click)="toggleCard()"
                (mouseenter)="onTriggerMouseEnter()"
                (mouseleave)="onTriggerMouseLeave($event)"
                (focusin)="onFocusIn()"
                (focusout)="onFocusOut($event)"
            >
                <ng-icon qpx size="sm" name="lucideInfo" />
                <span class="sr-only">{{ infoAriaLabel() }}</span>
            </button>
        </div>

        <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOpen]="cardOpen()"
            [cdkConnectedOverlayOrigin]="infoTrigger"
            [cdkConnectedOverlayPositions]="cardPositions"
            [cdkConnectedOverlayPush]="true"
            (overlayOutsideClick)="closeCard()"
            (detach)="closeCard()"
        >
            <div
                #card
                [id]="popupId"
                role="tooltip"
                class="metadata-card"
                [attr.aria-label]="cardAriaLabel()"
                (mouseenter)="onCardMouseEnter()"
                (mouseleave)="onCardMouseLeave($event)"
                (focusin)="onFocusIn()"
                (focusout)="onFocusOut($event)"
            >
                <ul class="m-0 grid list-none gap-3 p-0">
                    @for (item of hiddenItems(); track item.id) {
                        <li class="min-w-0">
                            <qpx-metadata
                                [id]="item.id"
                                [icon]="item.icon"
                                [label]="item.label"
                                [value]="item.overflowValue ?? item.value"
                                [ariaLabel]="
                                    item.overflowValue === undefined
                                        ? item.ariaLabel
                                        : undefined
                                "
                                [trailingIcon]="item.trailingIcon"
                                [trailingIconAriaLabel]="
                                    item.trailingIconAriaLabel
                                "
                                [trailingIconLabel]="item.trailingIconLabel"
                                [trailingIconContext]="item.trailingIconContext"
                                presentation="detail"
                            />
                        </li>
                    }
                </ul>
            </div>
        </ng-template>
    }
</div>

<div class="measurement" aria-hidden="true">
    <div
        #measurementRow
        data-testid="overflow-metadata-measurement-row"
        class="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1"
    >
        @for (item of items(); track item.id) {
            <div
                class="flex min-w-0 items-center gap-2"
                [attr.data-measure-item-id]="item.id"
            >
                @if (separator() && !$first) {
                    <span aria-hidden="true" class="text-muted">{{
                        separator()
                    }}</span>
                }
                <qpx-metadata
                    [presentation]="presentation()"
                    [id]="item.id"
                    [icon]="item.icon"
                    [label]="item.label"
                    [value]="item.value"
                    [ariaLabel]="item.ariaLabel"
                    [trailingIcon]="item.trailingIcon"
                    [trailingIconAriaLabel]="item.trailingIconAriaLabel"
                    [trailingIconLabel]="item.trailingIconLabel"
                    [trailingIconContext]="item.trailingIconContext"
                />
            </div>
        }

        <div class="relative size-4 shrink-0" data-measure-info-trigger>
            <button
                qpxButton
                matIconButton
                size="sm"
                class="absolute left-1/2 top-1/2 h-6 w-6 -translate-x-1/2 -translate-y-1/2"
                tabindex="-1"
            >
                <ng-icon qpx size="sm" name="lucideInfo" />
            </button>
        </div>
    </div>
</div>
